import User from 'data/User';
import { useState, useEffect } from 'react';
import { getStoreState, subscribeToStoreState } from 'state/Store';

export function useUser(): User | null {
  const [user, setUser] = useState<User | null>(() => getStoreState().app.user);

  useEffect(() => {
    function storeDidUpdate() {
      const newUser = getStoreState().app.user;
      // if (JSON.stringify(newUser) !== JSON.stringify(user)) {
      setUser(newUser);
      // }
    }
    const unsubscribe = subscribeToStoreState(storeDidUpdate);
    return () => {
      unsubscribe();
    };
  });

  return user;
}



// WEBPACK FOOTER //
// ./src/hooks/useUser.ts